export default __webpack_public_path__ + "static/media/9.3b451b3c.jpg";